export default "__VITE_ASSET__CcH7WM6a__"